import styled from 'styled-components';

export const Heading = styled.h1`
  font-size: 18px;
  color: #4b4d4e;
  font-weight: 700;
  margin: 0 0 32px 0;
`;

export const SubHeading = styled.h2`
  font-size: 16px;
  font-weight: 400;
  color: #444444;
  margin: 0 0 24px 0;
`;

export const ModalWrapper = styled.div`
  max-width: 1000px;
  padding: 40px 32px;

  @media (min-width: 950px) {
    padding: 48px 68px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 38px;

  > * {
    margin-left: 20px;
  }
`;
